<div class="sw-cms-block-moorl-twig">
    <slot name="content"></slot>
</div>